const COMBINING_MARKS = /[\u0300-\u036f]/g
const WHITESPACE = /\s+/
const MIN_FUZZY_WORD_LENGTH = 3

export function foldDiacritics (value: string): string {
  return String(value || '').normalize('NFD').replace(COMBINING_MARKS, '')
}

export function normalizeTerm (value: string): string {
  return foldDiacritics(value).toLowerCase().trim()
}

export function isWithinOneEdit (candidate: string, term: string): boolean {
  if (candidate === term) {
    return true
  }

  if (Math.abs(candidate.length - term.length) > 1) {
    return false
  }

  const [shorter, longer] = candidate.length <= term.length ? [candidate, term] : [term, candidate]
  const sameLength = shorter.length === longer.length
  let shorterIndex = 0
  let longerIndex = 0
  let edits = 0

  while (shorterIndex < shorter.length && longerIndex < longer.length) {
    if (shorter[shorterIndex] === longer[longerIndex]) {
      shorterIndex++
      longerIndex++
      continue
    }

    if (++edits > 1) {
      return false
    }

    if (sameLength) {
      shorterIndex++
    }

    longerIndex++
  }

  return true
}

function matchesWord (candidateWord: string, termWord: string): boolean {
  if (candidateWord.startsWith(termWord)) {
    return true
  }

  return termWord.length >= MIN_FUZZY_WORD_LENGTH && isWithinOneEdit(candidateWord, termWord)
}

export function matchesNormalized (haystack: string, needle: string): boolean {
  if (!needle) {
    return false
  }

  if (haystack.includes(needle)) {
    return true
  }

  const candidateWords = haystack.split(WHITESPACE)

  return needle
    .split(WHITESPACE)
    .every(termWord => candidateWords.some(candidateWord => matchesWord(candidateWord, termWord)))
}

export function matchesTerm (candidate: string, term: string): boolean {
  return matchesNormalized(normalizeTerm(candidate), normalizeTerm(term))
}

export function deriveDidYouMean (candidate: string, term: string): string {
  if (!candidate || !matchesTerm(candidate, term)) {
    return ''
  }

  const typed = String(term).toLowerCase().trim()

  return String(candidate).toLowerCase().includes(typed) ? '' : candidate
}
